import styles from './ShippingDetailsServicesTable.scss';
import Checkmark from 'dibs-icons/exports/legacy/Checkmark';
import { FormattedMessage } from 'dibs-react-intl';
import { shippingModal as messages } from '../shippingMessages';

// helpers
import classnames from 'classnames';

//cell classes
const cell = classnames(styles.serviceCell);
const headerCell = classnames(styles.serviceHeadCell, styles.serviceCell);

const methods = ['courier', 'standardExpress', 'frontDoor', 'inHomeDelivery'];

const services = [
    {
        key: 'item_collection_and_packing',
        label: (
            <FormattedMessage
                id="shipping.details.services.collectionAndPackaging"
                defaultMessage="Item collection and packaging"
            />
        ),
        courier: true,
        standardExpress: true,
        frontDoor: true,
        inHomeDelivery: true,
    },
    {
        key: 'shipping',
        label: (
            <FormattedMessage id="shipping.details.services.shipping" defaultMessage="Shipping" />
        ),
        courier: true,
        standardExpress: true,
        frontDoor: true,
        inHomeDelivery: true,
    },
    {
        key: 'handling_large_or_oversized_items',
        label: (
            <FormattedMessage
                id="shipping.details.services.handlingForLargeItems"
                defaultMessage="Handling for large or oversized items"
            />
        ),
        courier: false,
        standardExpress: false,
        frontDoor: true,
        inHomeDelivery: true,
    },
    {
        key: 'delivery_by_appointment',
        label: (
            <FormattedMessage
                id="shipping.details.services.deliveryByAppointment"
                defaultMessage="Delivery by appointment"
            />
        ),
        courier: false,
        standardExpress: false,
        frontDoor: false,
        inHomeDelivery: true,
    },
    {
        key: 'placement_in_room_of_choice',
        label: (
            <FormattedMessage
                id="shipping.details.services.placementInRoomOfChoice"
                defaultMessage="Placement in room of choice"
            />
        ),
        courier: false,
        standardExpress: false,
        frontDoor: false,
        inHomeDelivery: true,
    },
    {
        key: 'unpacking_and_inspection',
        label: (
            <FormattedMessage
                id="shipping.details.services.unpackingAndInspection"
                defaultMessage="Unpacking and inspection"
            />
        ),
        courier: false,
        standardExpress: false,
        frontDoor: false,
        inHomeDelivery: true,
    },
    {
        key: 'packing_removal',
        label: (
            <FormattedMessage
                id="shipping.details.services.packagingRemoval"
                defaultMessage="Packaging removal"
            />
        ),
        courier: false,
        standardExpress: false,
        frontDoor: false,
        inHomeDelivery: true,
    },
];

export function ShippingDetailsServicesTable() {
    const checkmarkImage = <Checkmark className={styles.checkmarkImage} />;
    return (
        <div className={styles.servicesTableContainer}>
            <table className={styles.servicesTable}>
                <thead>
                    <tr>
                        <th className={headerCell}>{messages.servicesIncluded}</th>
                        <th className={headerCell}>{messages.courier}</th>
                        <th className={headerCell}>{messages.standardExpress}</th>
                        <th className={headerCell}>{messages.frontDoor}</th>
                        <th className={headerCell}>{messages.inHomeDelivery}</th>
                    </tr>
                </thead>
                <tbody>
                    {services.map(service => {
                        return (
                            <tr key={service.key}>
                                <td className={cell}>{messages.label(service.label)}</td>
                                {methods.map(method => (
                                    <td className={cell} key={`${service.key}-${method}`}>
                                        {service[method] ? checkmarkImage : ''}
                                    </td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <p>{messages.someShippingMethods}</p>
        </div>
    );
}
